module.exports = __webpack_public_path__ + "static/img/registerSuccess.fd983f6e.png";